import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import soundManager from '../utils/soundManager';

export default function CartItem({ item, onUpdateQty }) {
  const { language } = useLanguage();
  
  // Display name based on current language
  const displayName = language === 'zh' ? item.name : (item.nameEn || item.name);
  
  return (
    <div className="flex gap-3 md:gap-4 items-center">
      <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl overflow-hidden shrink-0">
        <img
          src={item.image || 'https://via.placeholder.com/150'}
          alt={displayName}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="flex-1 min-w-0">
        <h4 className="font-bold text-sm truncate">{displayName}</h4>
        {item.specialInstructions && (
          <p className="text-gray-400 text-xs truncate italic">
            {item.specialInstructions}
          </p>
        )}
      </div>
      <div className="flex items-center gap-2 md:gap-3 bg-gray-100 rounded-lg px-2 py-1">
        <button
          onClick={() => {
            soundManager.playTap();
            onUpdateQty(item.cartItemId, -1);
          }}
          className="text-gray-500 hover:text-orange-500 w-6 h-6 flex items-center justify-center"
        >
          -
        </button>
        <span className="font-bold text-sm w-4 text-center">{item.qty}</span>
        <button
          onClick={() => {
            soundManager.playTap();
            onUpdateQty(item.cartItemId, 1);
          }}
          className="text-gray-500 hover:text-orange-500 w-6 h-6 flex items-center justify-center"
        >
          +
        </button>
      </div>
    </div>
  );
}


